<template>
	<v-dialog scrollable persistent v-model="showDialog" max-width="800px">
		<v-card>
			<v-card-title>Workbook Preview</v-card-title>
			<v-tabs
				v-if="workbookReports && workbookReports.length > 0"
				class="px-2"
				v-model="tab"
				center-active
				show-arrows
				style="flex: none"
			>
				<v-tab
					v-for="(report, index) in workbookReports"
					:key="index"
					@change="setReport(report)"
					>{{ report.TabName }}</v-tab
				>
			</v-tabs>
			<v-container
				fluid
				class="flexContainerItem pb-0"
				style="overflow: hidden"
			>
				<report-preview
					v-if="report"
					:report="report"
					:workbook="workbook"
				></report-preview>
			</v-container>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose()">Close</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { ReportPreviewActions } from '../../../../store/actions';
import ReportPreview from '../reportDetails/reportPreview/ReportPreview.vue';
export default {
	name: 'WorkbookPreview',
	props: {
		showDialog: Boolean,
		workbook: Object,
	},
	components: {
		ReportPreview,
	},
	computed: {
		workbookReports() {
			if (!this.workbook) return [];
			if (!this.workbook.WorkbookReports) return [];
			let wr = JSON.parse(JSON.stringify(this.workbook.WorkbookReports));
			return wr.sort((a, b) => (a.Order > b.Order ? 1 : -1));
		},
	},
	data() {
		return {
			tab: 0,
			report: null,
		};
	},
	mounted() {
		if (this.workbookReports && this.workbookReports.length > 0) {
			let report = this.workbookReports[0].Report;
			this.setReport(report);
			this.report = report;
		}
	},
	destroyed() {
		this.$store.dispatch(ReportPreviewActions.CLEAR);
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		setReport(item) {
			this.report = null;
			if (item.Report) {
				this.$store
					.dispatch(ReportPreviewActions.LOAD_REPORT, {
						report: item.Report,
						workbook: this.workbook,
					})
					.then(() => {
						this.report = item.Report;
					});
			}
		},
	},
};
</script>
